import { disableArrowKeys } from "components/dashboard/data-input-output-table/utils";
import React, { useState } from "react";
import { CellSubType } from "utils/enums";

const EditableCell = ({
  value,
  subType,
  onCommit,
  hideInputStyles,
}: {
  value: string;
  subType: CellSubType;
  onCommit: (v: string) => void;
  hideInputStyles?: boolean;
}) => {
  const [local, setLocal] = useState(value);

  const handleKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      onCommit(local);
      (e.target as HTMLInputElement).blur();
    }
    disableArrowKeys(e);
    if (subType === CellSubType.LONG) {
      if ([".", ",", "e", "E", "+"].includes(e.key)) e.preventDefault();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    if (subType === CellSubType.LONG && !/^-?\d*$/.test(v)) return;
    setLocal(v);
  };

  return (
    <input
      type="text"
      value={local}
      onChange={handleChange}
      onKeyDown={handleKey}
      onBlur={() => onCommit(local)}
      style={hideInputStyles ? { width: `${local.toString().length || 1}ch` } : {}}
      className={`${hideInputStyles ? "outline-none border-none bg-transparent p-0 mr-3" : "p-inputtext p-component w-full"}`}
    />
  );
};

export default EditableCell;
